import React from "react";

const DocSection = ({ id, title, children, className = "" }) => {
  return (
    <section id={id} className={`doc-section ${className}`}>
      {title && <h2 className="doc-section-title">{title}</h2>}
      <div className="doc-section-content">{children}</div>
    </section>
  );
};

export const DocSubsection = ({ id, title, children, className = "" }) => {
  return (
    <div id={id} className={`doc-subsection doc-section ${className}`}>
      {title && <h3 className="doc-subsection-title">{title}</h3>}
      <div className="doc-subsection-content">{children}</div>
    </div>
  );
};

export const DocNote = ({ type = "info", children }) => {
  const icons = {
    info: "bi-info-circle",
    tip: "bi-lightbulb",
    warning: "bi-exclamation-triangle",
    important: "bi-exclamation-circle",
  };

  return (
    <div className={`doc-note doc-note-${type}`}>
      <i className={`bi ${icons[type]}`}></i>
      <div className="doc-note-content">{children}</div>
    </div>
  );
};

export const DocStep = ({ number, title, children }) => {
  return (
    <div className="doc-step">
      <div className="doc-step-number">{number}</div>
      <div className="doc-step-content">
        <h4 className="doc-step-title">{title}</h4>
        {children}
      </div>
    </div>
  );
};

export const DocImage = ({ src, alt, caption }) => {
  return (
    <figure className="doc-image">
      <img src={src} alt={alt} className="img-fluid" />
      {caption && <figcaption className="doc-image-caption">{caption}</figcaption>}
    </figure>
  );
};

export default DocSection;
